import React, { useEffect, useState } from 'react';
import Navbar from './navbar';
import korrectLogo from "../../assets/images/korrectLogo.png";
import cachingMechanisum from '../Common/cachingMechanisum';
import { openDB } from 'idb';

export default function Header(param: any) {

    const [flag, setFlag] = useState(true);
    let [clientLogo, setclientLogo] = useState<any>([]);

    useEffect(() => {


        openDB('MyAppDB', 1, {
            upgrade(db) {
                if (!db.objectStoreNames.contains('cacheStore')) {
                    db.createObjectStore('cacheStore');
                }
            }
        }).then((db) => {
            db.get('cacheStore', 'ClientDSP').then((data) => {
                if (data) {
                    //console.log(data)
                }
            });
        });

        cachingMechanisum.individalcachingStorageBuild("All");
        //cachingMechanisum.individalcachingStorageBuild("ClientDSP");

        /*cachingMechanisum.individalcachingStorageBuild("tagColor");
        cachingMechanisum.individalcachingStorageBuild("lookUpType");
        cachingMechanisum.individalcachingStorageBuild("ClientDetails");
        cachingMechanisum.individalcachingStorageBuild("SystemFormats");
        //cachingMechanisum.individalcachingStorageBuild("SystemPeriod");
        cachingMechanisum.individalcachingStorageBuild("labelList"); */

        var apiTheme = cachingMechanisum.getCachingStorage("SiteTheme")
        clientLogo = cachingMechanisum.getCachingStorage("ClientImage")
        setclientLogo(clientLogo)
        for (var i = 0; i < apiTheme?.length; i++) {
            const styleElement = document.createElement('style');
            styleElement.innerHTML = apiTheme[i].className + '{ ' + apiTheme[i].attribute + ' : ' + apiTheme[i].value + ' !important ;} ';
            document.head.appendChild(styleElement);
        }

    }, [param.Title]);


    return (
        <div className='ws-12'>
            <div className='ws-12' >
                <a className='mtl mll pull-left' href='../../'><img src={korrectLogo} height='49px' /></a>
                <img className='mtl pull-left' src={clientLogo ? clientLogo : '/assets/images/logo.png'} height='49px' />

                <Navbar />

            </div>

            {(param.Title) && <div className=''>
                <div className='box-header-main'>
                    <h2 className='ws-8'>{param.Title ? param.Title : ''}</h2>


                    {(param.Title === 'Contacts' || param.Title === 'Contracts' || param.Title === 'Projects') && <div className='pull-right'>

                        {(param.Title !== 'Projects') && <a href="/projects/" className="btn-info btn-s" >Projects <i className="icon-Grid_ProjectContract" /> </a>}

                        {(param.Title !== 'Contracts') && <a href="/contracts/" className="btn-info btn-s" >Contracts <i className="icon-Grid_Contracts" /> </a>}

                        {(param.Title !== 'Contacts') && <a href="/contacts/" className="btn-info btn-s"> Contacts <i className="icon-Grid_Contacts" />  </a>}
                    </div>}
                </div>

            </div>}
        </div>
    )

}